<template>
  <div class="layout-inner insights">

    <navbar></navbar>

    <div class="layout-container">
      <div class="layout-content">

        <template v-if="isLoading">
          <div class="w-100" style="padding: 150px 0;">
            <spinner size="large"></spinner>
          </div>
        </template>

        <template v-else>

          <div class="hd_bar">
            <div class="hd_ic">
              <span class="ic-insight"></span>
            </div>
            <div class="hd_txt">
              <span class="title_txt">Exploring Insights</span>
            </div>
          </div>

          <div class="container-fluid flex-grow-1 pg_content_container">
            <explore-insight-list :type="'insights'" v-if="!isLoading"></explore-insight-list>
          </div>

        </template>

      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Navbar from '../../misc/components/./Navbar'
import ExploreInsightList from '../../explore/components/ExploreInsightList'

export default {
  name: 'explore-insights-results',
  components: {
    Navbar,
    ExploreInsightList
  },
  data: () => {
    return {
      isLoading: true
    }
  },

  mounted () {
    this.loadExploreInsights()
  },

  methods: {
    ...mapActions([
      'setCurrentFacet'
    ]),
    loadExploreInsights () {
      this.setCurrentFacet('insights')
      this.isLoading = false
    }
  },
  computed: {
    ...mapState({
      'currentFacet': state => state.explore.currentFacet
    })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreInsightsResults.vue